/**
 * Homepage Report Video Modal
 */
(function() {
	'use strict';

	const videoModal = document.getElementById('homepage-report-video-modal');
	if (!videoModal) return;

	const playButtons = document.querySelectorAll('.homepage-report__play-button');
	const modalContent = videoModal.querySelector('.homepage-report__video-modal-content');

	// Handle play button clicks
	playButtons.forEach(button => {
		button.addEventListener('click', function(e) {
			e.preventDefault();
			const videoEmbed = this.getAttribute('data-video-embed');
			const videoUrl = this.getAttribute('data-video-url');
			
			// Clear previous content
			modalContent.innerHTML = '';

			if (videoEmbed) {
				// Embedded video (YouTube, Vimeo, etc.)
				modalContent.innerHTML = '<div class="homepage-report__video-embed">' + videoEmbed + '</div>';
			} else if (videoUrl) {
				// Video file
				modalContent.innerHTML = '<video class="homepage-report__video-player" controls autoplay><source src="' + videoUrl + '" type="video/mp4">Your browser does not support the video tag.</video>';
			} else {
				// No video available
				modalContent.innerHTML = '<p>No video available.</p>';
			}
		});
	});

	// Pause video when modal is closed
	videoModal.addEventListener('hidden.bs.modal', function() {
		const video = modalContent.querySelector('video');
		if (video) {
			video.pause();
			video.currentTime = 0;
		}
		
		// Stop embedded videos (YouTube, Vimeo, etc.)
		const iframe = modalContent.querySelector('iframe');
		if (iframe) {
			const iframeSrc = iframe.src;
			iframe.src = '';
			iframe.src = iframeSrc;
		}
	});
})();

